module.exports = __webpack_public_path__ + "static/media/sketch_01.90ac4d42.png";